



























































































































































































































































































import imageCategories from '@/constants/property-image-categories.constant';
import ModalTabMixin from '@/mixins/modal-tab.mixin';
import { compass } from '@resclick/compass';
import { Component, Mixins } from 'vue-property-decorator';

interface IEditFile {
  id?: string;
  progress: number;
  preview: string;
  size: number;
  processing: boolean;
  file?: File;
  meta: {
    isLogo: boolean;
    isFeaturedImage: boolean;
    category: string;
    roomTypes: string[];
  };
}

interface IImage {
  id: string;
  name: string;
  sizes: {
    thumbnail: string;
    small: string;
    medium: string;
    large: string;
    full: string;
    extra: string;
  };
  meta: {
    isLogo: boolean;
    isFeaturedImage: boolean;
    category: string;
    roomTypes: string[] | { id: string }[];
  };
  path: string;
  fileSize: number;
}

@Component
export default class TabImages extends Mixins(ModalTabMixin) {
  showEditor = false;
  images: IImage[] = [];

  isEditMode = false;

  editImages: IEditFile[] = [];

  /* Image Groups */
  get propertyImages() {
    return this.images.filter((image: IImage) => !this.roomImages.includes(image));
  }

  get roomImages() {
    return this.images.filter((image: IImage) => image.meta && image.meta.roomTypes && image.meta.roomTypes.length);
  }

  get roomImagesGrouped() {
    const roomTypes: any = {};
    for (const roomImage of this.roomImages) {
      const refs = roomImage.meta.roomTypes;
      for (const ref of refs) {
        if (typeof ref === 'object' && ref.id) {
          if (!roomTypes[ref.id]) {
            roomTypes[ref.id] = { ...ref, images: [roomImage] };
          } else {
            roomTypes[ref.id].images.push(roomImage);
          }
        }
      }
    }
    return roomTypes;
  }

  /* Image Options*/
  get categoryOptions() {
    return imageCategories;
  }

  get roomCategory() {
    return this.categoryOptions.find((category) => category.key === 'ROOM');
  }

  get roomCategoryKeys() {
    return (this.roomCategory as any).children.flatMap((sub: any) => sub.children.flatMap((item: any) => item.key));
  }

  get thumbURL() {
    return (image: IImage) => {
      const size = image.meta.isFeaturedImage ? 'medium' : 'small';
      const imagePath = image.sizes ? image.sizes[size] : image.path;
      return process.env.VUE_APP_CDN_URL + imagePath;
    };
  }

  get imageURL() {
    return (image: IImage) => {
      const imagePath = image.sizes ? image.sizes.full : image.path;
      return process.env.VUE_APP_CDN_URL + imagePath;
    };
  }

  get totalProgress() {
    return (
      this.editImages.reduce((total: number, image: any) => {
        total += image.progress;
        return total;
      }, 0) / this.editImages.length
    );
  }

  get isProcessing() {
    return this.editImages.some((image) => image.processing);
  }

  get getEditIndex() {
    return (image: IImage) => this.editImages.findIndex((i) => i.id === image.id);
  }

  onShowEditorClick() {
    if (this.editImages.length) {
      this.showEditor = true;
    }
  }

  cancelEditMode() {
    this.editImages = [];
    this.isEditMode = false;
  }

  async deleteSelectedImages() {
    if (this.editImages.length) {
      const promises: Array<Promise<any>> = [];
      for (const image of this.editImages) {
        promises.push(
          compass.do('properties', 'deleteImage', {
            params: {
              propertyId: this.id as string,
              fileId: image.id as string,
            },
          }),
        );
      }
      this.loading = true;
      await Promise.all(promises);
      this.loading = false;
      this.editImages = [];
      this.isEditMode = false;
      this.getImages();
    }
  }

  async deleteEditImage(image: IEditFile, index: number) {
    if (image.id) {
      await compass.do('properties', 'deleteImage', {
        params: { propertyId: this.id as string, fileId: image.id as string },
      });
    }

    this.editImages.splice(index, 1);
  }

  async generatePreviewImage(blob: Blob) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = () => resolve(reader.result);
    });
  }

  isRoomImage(image: IEditFile) {
    return image && image.meta && image.meta.category && this.roomCategoryKeys.includes(image.meta.category);
  }

  async setEditor(event: Event & { target: HTMLInputElement }) {
    const images = event.target.files;
    if (images) {
      for (let i = 0; i < images.length; i++) {
        const image = images[i];
        const file = {
          progress: 0,
          preview: Object.freeze((await this.generatePreviewImage(image)) as string),
          size: image.size,
          processing: false,
          file: Object.freeze(image),
          meta: {
            isLogo: false,
            isFeaturedImage: false,
            category: '',
            roomTypes: [],
          },
        };

        this.editImages.push(file);
      }

      this.showEditor = true;
    }
  }

  async changeImage(image: IEditFile, event: Event & { target: HTMLInputElement }) {
    const images = event.target.files;
    if (images && images[0]) {
      image.progress = 0;
      image.processing = false;
      image.preview = Object.freeze(await this.generatePreviewImage(images[0])) as string;
      image.file = Object.freeze(images[0]);
    }
  }

  upload() {
    for (const image of this.editImages) {
      const formData: any = new FormData();
      image.processing = true;
      if (image.file) formData.append('file', image.file, image.file.name);
      image.meta.roomTypes = image.meta.roomTypes.map((roomType: any) => (roomType.id ? roomType.id : roomType));
      formData.append('meta', JSON.stringify(image.meta));

      const action = image.id ? 'updateImage' : 'addImage';

      compass
        .do('properties', action, {
          params: { propertyId: this.id as string, fileId: image.id },
          data: formData,
          // formData,
          onUploadProgress: (progressEvent: ProgressEvent) => {
            image.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          },
        })
        .then(() => {
          image.processing = false;

          if (!this.isProcessing) {
            this.showEditor = false;
            this.isEditMode = false;
            this.editImages = [];
            this.getImages();
          }
        });
    }
  }

  async onThumbClick(image: IImage) {
    const itemIndex = this.getEditIndex(image);

    if (itemIndex < 0) {
      this.editImages.push({
        id: image.id,
        progress: 0,
        preview: this.imageURL(image),
        size: image.fileSize,
        processing: false,
        meta: Object.assign(
          {
            isLogo: false,
            isFeaturedImage: false,
            category: '',
            roomTypes: [],
          },
          image.meta,
        ),
      });
    } else {
      this.editImages.splice(itemIndex, 1);
    }
  }

  closeEditor() {
    this.showEditor = false;
    this.getImages();
  }

  getImages() {
    this.loading = true;
    compass
      .do('properties', 'findImages', {
        params: { propertyId: this.id as string },
        limit: 100,
        populate: [
          {
            path: 'meta.roomTypes',
            select: ['displayName'],
          },
        ],
      })
      .then(({ data }: any) => {
        this.images = data;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  async created() {
    this.getImages();
  }
}
